import { isImage } from '#pplx/frontend/common/files/images.js';
export function truncateFilenameString(string, maxLength, numEllipsis = 2) {
    if (string == null)
        return '';
    const extension = string.includes('.') ? string.slice(string.lastIndexOf('.')) : '';
    const baseName = string.substring(0, string.length - extension.length);
    if (baseName.length > maxLength) {
        return (baseName.substring(0, maxLength - extension.length - 3) + '.'.repeat(numEllipsis) + extension);
    }
    else {
        return baseName + extension;
    }
}
export const isFileImage = (file) => {
    return file.file.type.includes('image');
};
export const hasCurrentImageUpload = (uploadedFiles) => {
    return (uploadedFiles?.some((uploadedFile) => {
        if (uploadedFile.file.type) {
            return isImage(uploadedFile.file);
        }
        return Boolean(uploadedFile.nextURL && isImage(uploadedFile.file.name));
    }) ?? false);
};
export const isFilePDF = (file) => {
    return file.file.type === 'application/pdf';
};
export const isFileSpreadsheet = (file) => {
    return (file.file.type === 'text/csv' ||
        file.file.type == 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
};
export const isFileText = (file) => {
    return (file.file.type === 'text/plain' ||
        file.file.type === 'application/msword' ||
        file.file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' ||
        file.file.type === 'text/markdown');
};
export const ExtensionToMimeType = {
    txt: 'text/plain',
    pdf: 'application/pdf',
    jpeg: 'image/jpeg',
    jpg: 'image/jpeg',
    doc: 'application/msword',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    pptx: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    md: 'text/markdown',
    png: 'image/png',
    csv: 'text/csv',
};
export const formatBytes = (numBytes, intl) => {
    if (numBytes < 0)
        throw new Error('Number of bytes cannot be negative');
    const units = ['byte', 'kilobyte', 'megabyte', 'gigabyte'];
    let unitIndex = 0;
    let value = numBytes;
    while (value >= 1000 && unitIndex < units.length - 1) {
        value /= 1000;
        unitIndex++;
    }
    const fractionDigits = value % 1 === 0 ? 0 : 1;
    return intl.formatNumber(Number(value.toFixed(fractionDigits)), {
        style: 'unit',
        unit: units[unitIndex],
        unitDisplay: 'short',
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: fractionDigits,
        useGrouping: false,
    });
};
//# sourceMappingURL=fileUploadUtils.js.map